import Typography from '@mui/material/Typography'
import type { GridColDef } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'

import CustomDataGrid from '@/components/dataDisplay/CustomDataGrid'
import { DEFAULT_DATA_GRID_PAGINATION_MODEL } from '@/constants/datagrid'
import type { ResourceMinView } from '@/features/unavailability/types/resourceMinView'
import type { MarketProgramType } from '@/types/marketProgramType'

interface ResourcesMinViewDataGridProps {
  resources: ResourceMinView[]
}

export const ResourcesMinViewDataGrid = (props: ResourcesMinViewDataGridProps) => {
  const { t } = useTranslation()
  const { resources } = props

  const columns: GridColDef<ResourceMinView>[] = [
    {
      field: 'name',
      headerName: t('common.resources'),
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: 'type',
      headerName: t('common.type'),
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: 'marketPrograms',
      headerName: t('common.market_program.label'),
      flex: 1,
      valueFormatter: (value: MarketProgramType[]) =>
        value?.map((marketProgram) => t(`common.market_program.${marketProgram}`)).join(', '),
      disableColumnMenu: true,
    },
  ]

  return (
    <>
      <Typography sx={{ mt: 2 }} variant="h6">
        {t('customer_details.tabs.availability.affected_resources')}
      </Typography>

      <CustomDataGrid
        disableColumnSorting
        columns={columns}
        includeWrapper={false}
        initialState={{
          pagination: {
            paginationModel: DEFAULT_DATA_GRID_PAGINATION_MODEL,
          },
        }}
        rows={resources}
      />
    </>
  )
}
